export default __webpack_public_path__ + "static/media/Room4.3afbf4f7.png";